import EditorScrollingBodyContainer from './EditorScrollingBodyContainer';
import styled from 'foundations-theming/utils';
import EditorFixedHeaderContainer from './EditorFixedHeaderContainer';
import EditorTitleHeader from './EditorTitleHeader';
import ConditionEditor from '../common/ConditionEditor';
import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorConditionWrapperContainer = styled.div.withConfig({
  displayName: "EditorConditionWrapper__EditorConditionWrapperContainer",
  componentId: "f7rtm2-0"
})(({
  theme
}) => ({
  backgroundColor: theme.color['fill-field-default'],
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
}));
const EditorConditionWrapper = ({
  conditionPath,
  filterFamily,
  inputUse
}) => {
  return /*#__PURE__*/_jsx(EditorConditionWrapperContainer, {
    "data-test-id": "fr-editor",
    children: /*#__PURE__*/_jsx(ScrollingColumn, {
      headerContent: /*#__PURE__*/_jsx(EditorFixedHeaderContainer, {
        children: /*#__PURE__*/_jsx(EditorTitleHeader, {})
      }),
      children: /*#__PURE__*/_jsx(EditorScrollingBodyContainer, {
        "data-test-id": "fr-editor-conditions",
        children: /*#__PURE__*/_jsx(ConditionEditor, {
          conditionPath: conditionPath,
          filterFamily: filterFamily,
          inputUse: inputUse
        })
      })
    })
  });
};
export default EditorConditionWrapper;